
<template>
  <div id="adminSetting">
    <Header :title="$t('Header.SuperAmin')" logoutPath="/SuperAdmin/Login" />
    <Menu />

    <div class="pnlBEContent scrollBar">
      <TitleBar :iconSrc="require('@/assets/img/backend/icon_lock_2.png')" :title="$t('SAAdminSetting.PageName')">
        <input type="text" class="txtbSearch" v-model="searchFilter" placeholder="請輸入學校名稱、帳號" />
        <div class="pnlUploadArea" style="margin: 21.5px 0 0 12px">
          <label class="btnWidthIcon iconImport">{{ $t('ClassSetting.ImportStudent') }}</label>
          <input
            type="file"
            id="fileAccount"
            accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            class="fuClass"
            @change="ImportAdmin"
          />
        </div>
        <button class="btnWidthIcon iconDownload" style="margin: 21.5px 0 0 0" @click="DownloadAccountExample()">
          {{ $t('ClassSetting.DownloadExample') }}
        </button>
      </TitleBar>

      <div class="pnlBESearchScroll">
        <table class="AdminSettingTable">
          <tr>
            <th>縣市</th>
            <th>學校</th>
            <th>主帳號</th>
            <th>裝置數量</th>
          </tr>
          <tr v-for="item in filterData" :key="item.serial" @click="SchoolDetail(item)">
            <td>{{ item.county }}</td>
            <td>{{ item.school }}</td>
            <td>{{ item.account }}</td>
            <td>{{ item.machineNum }}</td>
          </tr>
          <tr v-show="filterData.length == 0">
            <td colspan="4">此篩選條件查無資料，請更改篩選條件。</td>
          </tr>
        </table>
      </div>
    </div>

    <DialogAdminSetting
      :show="dialogAdmin.isShow"
      :serial="dialogAdmin.serial"
      :school="dialogAdmin.school"
      @close-dialog="CloseDialog"
    />
    <DialogOneBtn
      :show="dialogMsg.isShow"
      :msgWarning="dialogMsg.msg"
      :btnTxt="dialogMsg.btnTxt"
      @btn-click="CloseMsg"
    />
    <Loading
      :active.sync="loadingInfo.isLoading"
      :can-cancel="false"
      :is-full-page="true"
      :color="loadingInfo.color"
      :opacity="loadingInfo.opacity"
      :background-color="loadingInfo.bgColor"
    ></Loading>
  </div>
</template>

<script>
import Header from '@/components/Header.vue';
import Menu from '@/components/SuperAdmin/Menu.vue';
import TitleBar from '@/components/TitleBar.vue';
import DialogAdminSetting from '@/components/Dialog/DialogAdminSetting.vue';
import DialogOneBtn from '@/components/Dialog/DialogOneBtn.vue';
import { apiGetAccountList, apiImportAdminAccount } from '@/request.js';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
  data() {
    return {
      searchFilter: '',
      loadingInfo: {
        isLoading: false,
        color: '#fff',
        opacity: 0.9,
        bgColor: '#131217',
      },
      dialogAdmin: {
        isShow: false,
        serial: 0,
        school: '',
      },
      dialogMsg: {
        isShow: false,
        msg: '',
        btnTxt: '',
      },
      data: [],
    };
  },
  mounted() {
    this.GetAdminList();
  },
  computed: {
    filterData: function () {
      if (this.searchFilter) {
        return this.data.filter((info) => {
          let school = info.school.toLowerCase();
          let account = info.account.toLowerCase();
          let keyword = this.searchFilter.toLowerCase();
          return school.indexOf(keyword) != -1 || account.indexOf(keyword) != -1;
        });
      } else {
        return this.data;
      }
    },
  },
  methods: {
    GetAdminList() {
      // this.data = [
      //   { serial: 1, county: '高雄市', school: '民權國小', account: 'school_aaa@gmail.com', machineNum: 4 },
      //   { serial: 2, county: '高雄市', school: '四維國小', account: 'school_bbb@gmail.com', machineNum: 4 },
      //   { serial: 3, county: '高雄市', school: '河堤國小', account: 'school_ccc@gmail.com', machineNum: 4 },
      //   { serial: 4, county: '高雄市', school: '龍華國小', account: 'school_ddd@gmail.com', machineNum: 4 },
      //   { serial: 5, county: '台北市', school: '永春國小', account: 'school_eee@gmail.com', machineNum: 6 },
      // ];
      apiGetAccountList().then((res) => {
        //console.log(JSON.stringify(res.data.data));
        this.data = res.data.data;
      });
    },
    SchoolDetail(item) {
      this.dialogAdmin.school = item.school;
      this.dialogAdmin.serial = item.serial;
      this.dialogAdmin.isShow = true;
      //console.log('SchoolDetail serial:' + item.serial);
    },
    ImportAdmin(event) {
      this.loadingInfo.isLoading = true;
      let postforms = new FormData();
      postforms.append('file', event.target.files[0]);
      apiImportAdminAccount(postforms).then((res) => {
        //console.log(JSON.stringify(res.data));
        this.loadingInfo.isLoading = false;
        if (res.data != null && res.data.status == 'ok') {
          this.data = this.data.concat(res.data.data);
          this.dialogMsg.msg = '匯入成功';
        } else if (res.data != null && res.data.status == 'failed') {
          this.dialogMsg.msg = `錯誤, ${JSON.stringify(res.data.error)}`;
        }
        this.dialogMsg.btnTxt = '好';
        this.dialogMsg.isShow = true;
        //clear file
        document.getElementById('fileAccount').value = '';
      });
    },
    CloseDialog() {
      this.dialogAdmin.isShow = false;
      this.GetAdminList();
    },
    CloseMsg() {
      this.dialogMsg.isShow = false;
    },
    DownloadAccountExample() {
      let url = 'https://surreal-edu.s3.ap-northeast-1.amazonaws.com/ImportAccount.xlsx';
      window.open(url);
    },
  },
  components: {
    Header,
    Menu,
    TitleBar,
    DialogAdminSetting,
    DialogOneBtn,
    Loading,
  },
};
</script>
